<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="4" right>呵呵，哈哈哈！如你所說，不愧是文學偵探啊！</npc>
              <npc :npc-id="1">⋯⋯等、等一下。誰？誰是林先生啊？</npc>
              <npc :npc-id="0">是賴和先生寫的〈善訟的人的故事〉的主角。</npc>
              <npc :npc-id="1">等等，這是怎麼回事？你說怪盜是虛構人物！？</npc>
              <npc :npc-id="0">這有什麼不可思議的？剛剛那個游移在不同時空之外的彰化警察署跟時間警察，跟虛構的有何兩樣？我們早就被帶到虛實不分的世界裡了。</npc>
              <npc :npc-id="1">不是，等一下，呂善安，你是怎麼知道的啊！太突然了吧？聽都沒聽過！推理小說裡，犯人不是應該是前期登場的人物嗎？</npc>
              <npc :npc-id="0">是啊，怪盜一開始就登場了，說明已登場人物的動機，本來就是推理故事後期的發展。</npc>
              <npc :npc-id="1">但你怎麼知道？根本沒線索啊！</npc>
              <npc :npc-id="0">有啊！其中一個線索，是開化寺跟賴和先生的生平沒有明確關聯，跟之前怪盜讓我們『證明』的地點不同，唯一的關聯，就是〈善訟的人的故事〉；所以這篇小說必然有某種重要性。事實上，怪盜的名片也提示了這個重要性。</npc>
              <npc :npc-id="1">名片？你是說這個嗎？</npc>

              <story-image :src="require(`@/assets/images/pics/第7章_2-1_名片與簽名.jpg`)"></story-image>
              <!-- （圖片：怪盜的名片） -->

              <npc :npc-id="0">沒錯，你仔細看。這個符號其實是典型的『組合字』，原理就像常見的春聯『招財進寶』一樣。</npc>
              <npc :npc-id="1">招財進寶？啊！你是說這個嗎？</npc>

              <story-image :src="require(`@/assets/images/pics/第7章_2-2_「招財進寶」組合字.jpg`)"></story-image>
              <!-- （圖片：手寫的招財進寶組合字） -->

              <npc :npc-id="0">對。然後呢，如果你把名片上的組合字拆開——</npc>
              <npc :npc-id="1">——這是！耕牛無草？</npc>
              <npc :npc-id="0">沒錯，這四個字就是出自〈善訟的人的故事〉，因此『簽名』暗示了怪盜跟這篇小說有關。</npc>
              <npc :npc-id="1">那你剛剛說的林先生到底是誰？</npc>
              <npc :npc-id="0">故事中，彰化這邊的百姓沒錢給地主，甚至連葬身之地都買不起，原本受僱於地主的林先生為老百姓抱不平，因此為百姓寫狀紙，到了福州要找官府。茶館裡，林先生遇到一位善訟的人，那人建議他在狀紙上加入十六個字——</npc>
              <npc :npc-id="1">啊，就是剛剛看到的十六個字？</npc>
              <npc :npc-id="0">對，接下來發生的事，就有些不可思議了。林先生打贏官司後，原本應該回鄉接受百姓愛戴，但他居然從此失蹤，沒人知道他到哪去了，甚至有人懷疑他被殺害。</npc>
              <npc :npc-id="1">咦？所以主角最後失蹤了？</npc>
              <npc :npc-id="0">嗯。我看〈善訟的人的故事〉的時候大惑不解，心想這有什麼文學上的寓意嗎？但要是事實更加單純，林先生之所以沒有回彰化，是因為遇到了什麼不可思議之事——林先生，這點你要不要親自說明呢？</npc>
              <npc :npc-id="4" right>真厲害，呂善安君，居然對這篇小說這麼清楚；沒錯，我就是代百姓告狀的林先生。原本我想回彰化，沒想到被捲進某件怪事裡，穿越時空，雖然事後我得到了某種異能，能一定程度上穿越時空，但怎樣也回不到原本的時代了。</npc>
              <npc :npc-id="1">到底是怎樣的怪事啊！該不會是那種勇者的大冒險吧？</npc>
              <npc :npc-id="4" right>哈哈哈，差不多吧？反正在那之後，我年紀也不會增長了，就在不同時間裡學了很多事，所以我才會發現我是賴和先生筆下的人物，也知道文學偵探呂善安的存在。</npc>
              <npc :npc-id="0">看來你已經接受自己是虛構人物的事實了⋯⋯林先生，你能把一切告訴誠實告知嗎？為何你要做這些事？為何需要我？</npc>
              <npc :npc-id="4" right>當然，我在你面前露臉，就是打算坦白。但你能陪我進行最後的『證明』嗎？</npc>
              <npc :npc-id="0">⋯⋯也無不可，你想去哪裡？</npc>
              <npc :npc-id="4" right>高賓閣——現在的彰化鐵路醫院。</npc>

              <map-link name="彰化鐵路醫院" map-id="JCqSGVNeahdNSJQf8"/>

              <move-to-stage-btn link="前往高賓閣">前往高賓閣</move-to-stage-btn>

              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>
      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage7_2',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第七章 - 2',
      isQuestion: false,
      stageId: 'virtual',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
